import { Components, Theme } from '@mui/material/styles';

export const flowStepContent: Components<Theme>['MuiStepContent'] = {
  // stepContent is styled from stepper.theme.ts
};
